import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toFixed',
})
export class ToFixedPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): unknown {
    if (typeof value !== 'number') return value;

    const valueStr = String(value);
    const decimalPart = valueStr.includes('.') ? valueStr.split('.')[1] : '';
    const decimalPlaces = Math.max(decimalPart.length, 2);

    return parseFloat(value.toFixed(decimalPlaces));
  }
}
